"use client";

import { motion } from "motion/react";
import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { AnimateProps } from "../types";

function Animate<T extends React.ElementType = "div">({
  as,
  asChild = false,
  className,
  ...props
}: AnimateProps<T>) {
  const Component = motion.create(resolveElement(asChild, as, "div"));
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Animate] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return <Component className={cn(className, classes)} {...native} />;
}

Animate.displayName = "Animate";

export default Animate;
